<script context="module" lang="ts">
	import icoMarker from 'iconoir/icons/map-pin.svg';
	import icoEdit from 'iconoir/icons/edit-pencil.svg';
	import getPermissions from '../auth/getPermissions';
	import Tag from '../utils/tag.svelte';

	const placeholderImage = import.meta.env.VITE_DEFAULTIMAGE;

	async function canEdit() {
		return await getPermissions('edit-event');
	}
</script>

<script lang="ts">
	export let id = null;
	export let eventImage = placeholderImage;
	export let eventName = 'Undefined';
	export let eventDesc = 'Undefined';
	export let eventStartDateTime = '01/01/2000 00:00';
	export let eventEndDateTime = '01/01/2000 00:00';
	export let eventCost = 'Unknown Cost';
	export let eventLocation = 'Undefined';
	export let eventCategory = 'General';
	export let eventImageFocal = 'center center';

	const parsedStartDate = new Date(eventStartDateTime);
	const parsedEndDate = new Date(eventEndDateTime);
	const dateMonthShort = parsedStartDate.toLocaleString('default', { month: 'short' });
	const dateDay = parsedStartDate.toLocaleDateString('default', { day: '2-digit' });
	const startDate = parsedStartDate.toLocaleDateString('default', {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit'
	});
	const endDate = parsedEndDate.toLocaleDateString('default', {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit'
	});
</script>

<div
	class="relative rounded-md bg-white p-2 pb-4 drop-shadow-sm md:border-[1px] md:border-zinc-100"
	itemscope
	itemtype="https://schema.org/Event"
>
	<meta itemprop="image" content={eventImage} />
	<div
		style="background: url({eventImage}); background-repeat: no-repeat; background-size: cover; background-position: {eventImageFocal}"
		class="relative min-h-[10rem] rounded"
	>
		<Tag class="absolute top-0 m-2" itemprop="price" content={eventCost} />
		<Tag class="absolute bottom-0 m-2" accent="True" content={eventCategory} />
	</div>
	<div
		class="mt-2 grid grid-cols-[4rem_minmax(0,_1fr)] grid-rows-[minmax(min-content,_max-content)_minmax(min-content,_max-content)] gap-1 gap-y-4"
	>
		<div class="m-auto mr-4 text-center">
			<p class="text-red-600">{dateMonthShort.toUpperCase()}</p>
			<p class="mb text-2xl">{dateDay}</p>
		</div>
		<div>
			<h2 itemprop="name" class="text-lg text-neutral-900 dark:text-neutral-100">{eventName}</h2>
			<p itemprop="description" class="text-neutral-800 dark:text-neutral-200">{eventDesc}</p>
			<p class="mt-1 text-sm text-neutral-700 dark:text-neutral-300">
				<span itemprop="startDate" content={startDate}>{startDate}</span>
				- <span itemprop="endDate" content={endDate}>{endDate}</span>
			</p>
		</div>
		<img class="m-auto" src={icoMarker} alt="" />
		<div class="flex items-center">
			<p class="text-neutral-900 dark:text-neutral-100" itemprop="location">{eventLocation}</p>
		</div>
	</div>

	{#await canEdit()}
		<div />
	{:then result}
		{#if result == true}
			<div class="absolute bottom-0 right-2">
				<a href="/events/edit/{id}" class="flex items-center">
					<img
						src={icoEdit}
						alt="Edit Icon"
						class="inline-block h-4"
						style="filter: invert(21%) sepia(19%) saturate(259%) hue-rotate(202deg) brightness(95%) contrast(86%);"
					/>
					<p class="ml-2 text-zinc-700">Edit</p>
				</a>
			</div>
		{/if}
	{/await}
</div>
